// removed by extract-text-webpack-plugin
module.exports = {"titleBlock":"titleBlock__2yWe5","titleBlockLhs":"titleBlockLhs__kmTdq","titleBlockRhs":"titleBlockRhs__Kge81","btn":"btn__Txarh","schoolTitle":"schoolTitle__1ZOQi","schoolTitleAvatar":"schoolTitleAvatar__1kbOC","schoolTitleText":"schoolTitleText__2FNWq","placeholderAvatar":"placeholderAvatar__174J1","supTitle":"supTitle__3yH15","schoolNameBadge":"schoolNameBadge__UtmtW","tabPageContainer":"tabPageContainer__2U-qj","tabAddProgramBtn":"tabAddProgramBtn__2BUG2"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/account/schoolPrograms/style.scss
// module id = 352
// module chunks = 0